import { spacing } from "../styles/Spacing";

export const serverError = {
    body: {
        padding: spacing.space2,
    },
};
